import React from "react";
import { Badge } from "Components/Base/DataDisplay/Badge";

const FilterHitCount = ({ hitCount, languageContext, showHitCount }) => {
  return hitCount && showHitCount && hitCount > 0 ? (
    <Badge
      badgeContent={hitCount && showHitCount ? hitCount : 0}
      color="primary"
    >
      <strong>{languageContext("hits")}:</strong>
    </Badge>
  ) : null;
};

export default FilterHitCount;
